import action from '../../../abstract/action.js';

export default action({
  label: 'Dodaj',
  icon: 'EditIcon',
  main: () => true,
  render: ({ item }) => item.id === null,
  handle: async ({ $router, item }) => await $router.push({
    path: '/admin/templates/work-parameters/add',
    query: { type: item.work_parameters_types_original },
  }),
});
